export { default, getServerSideProps } from 'pages/[lang]/[...slug]';
